import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import STRINGS from "../Constants/Strings";
import { RecentArchieveConversation } from "../Models/ConversationApiState";

interface EditConversationTitlePopupProps {
  visible: boolean;
  conversation: RecentArchieveConversation | null;
  onHide: () => void;
  onSave: (conversation: RecentArchieveConversation) => void;
}

const EditConversationTitlePopup: React.FC<EditConversationTitlePopupProps> = ({ visible, conversation, onHide, onSave }) => {
  const [newTitle, setNewTitle] = useState<string>(conversation?.title || "");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const isSaveButtonDisabled = !newTitle || newTitle.length < 10 || newTitle.length > 2000 || newTitle === conversation?.title;

  const handleSave = () => {
    if (conversation && !isSaveButtonDisabled) {
      conversation.title = newTitle;
      onSave(conversation);
      onHide();
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setNewTitle(value);
    if (!value || value.length < 10) {
      setErrorMessage("Title should be minimum 10 and maximum 2000 characters.");
    } else if (value.length > 2000) {
      setErrorMessage("Title should be maximum 2000 characters.");
    } else {
      setErrorMessage("");
    }
  };

  const footerContent = (
    <div>
      <Button className="me-2 rounded" label={STRINGS.EDITCONVERSATION.CANCEL_BUTTON} onClick={() => onHide()} severity="info" outlined />
      <Button className="rounded" label={STRINGS.EDITCONVERSATION.SAVE_BUTTON} onClick={() => handleSave()} disabled={isSaveButtonDisabled} style={{minWidth:"100px"}}/>
    </div>
  );

  if (!visible) return null;

  return (
    <Dialog
      visible={visible}
      modal
      header={STRINGS.EDITCONVERSATION.EDIT_CONVERSATION_TITLE}
      footer={footerContent}
      style={{ width: "40rem" }}
      onHide={() => {
        if (!visible) return;
        onHide();
      }}
      draggable={false}
    >
      <div className="flex flex-column gap-2">
        <label htmlFor="conversation-title " className="text-sm">{STRINGS.EDITCONVERSATION.CONVERSATION_TITLE_LABEL}</label>
        <InputText
          id="conversation-title"
          type="text"
          value={newTitle}
          className="w-100"
          onChange={handleInputChange}
          placeholder="Enter title"
          aria-describedby="conversation-error-help"
        />
        {errorMessage && (
          <small id="conversation-error-help" style={{ color: "var(--red-500)" }}>
            {errorMessage}
          </small>
        )}
      </div>
    </Dialog>
  );
};

export default EditConversationTitlePopup;
